import React from "react";
import { useParams } from "react-router-dom";
import { Container, Typography, Paper, Box } from "@mui/material";

const UserFormPage: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const isEdit = !!id;

  return (
    <Container maxWidth="md" sx={{ mt: 1.5, mb: 1.5, px: { xs: 1, sm: 1.5 } }}>
      <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider" }}>
        <Typography variant="h4" gutterBottom>
          {isEdit ? "Edit User" : "Create New User"}
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Typography variant="body1" color="text.secondary">
            User form functionality will be implemented here.
            {isEdit && ` Editing user with ID: ${id}`}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default UserFormPage;
